var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefective(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13417_12698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 20.5003H17.3334V23.167H14.6667V20.5003ZM14.6667 9.83366H17.3334V17.8337H14.6667V9.83366ZM15.9867 3.16699C8.62669 3.16699 2.66669 9.14033 2.66669 16.5003C2.66669 23.8603 8.62669 29.8337 15.9867 29.8337C23.36 29.8337 29.3334 23.8603 29.3334 16.5003C29.3334 9.14033 23.36 3.16699 15.9867 3.16699ZM16 27.167C10.1067 27.167 5.33335 22.3937 5.33335 16.5003C5.33335 10.607 10.1067 5.83366 16 5.83366C21.8934 5.83366 26.6667 10.607 26.6667 16.5003C26.6667 22.3937 21.8934 27.167 16 27.167Z",
    fill: "#EB628D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13417_12698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefective);
export default __webpack_public_path__ + "static/media/defective.81b1662b.svg";
export { ForwardRef as ReactComponent };